import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { PipesModule } from "@intocare/pipes";

import { DonutChartComponent } from "./donut/donut.component";
import { GraphComponent } from "./graph/graph.component";
import { ProgressChartComponent } from "./progress-chart/progress-chart.component";
import { SpeedOMeterComponent } from "./speedometer/speedometer.component";
import { StatsItemComponent } from "./stats/stats-item.component";

@NgModule({
	imports: [CommonModule, TranslateModule, NgxChartsModule, PipesModule],
	declarations: [GraphComponent, SpeedOMeterComponent, ProgressChartComponent, StatsItemComponent, DonutChartComponent],
	exports: [GraphComponent, SpeedOMeterComponent, ProgressChartComponent, StatsItemComponent, DonutChartComponent],
	providers: [],
})
export class GraphModule {}
